<script setup>
  import {
    onMounted,
    watch,
  } from 'vue'

  import { storeToRefs } from 'pinia'

  import { Loader } from "@googlemaps/js-api-loader"

  // import Property from '@components/PropertyLarge.vue'

  import { useAjax } from '@composables/useAjax.js'
  import { useWatchWindowSize } from '@composables/useWatchWindowSize.js'
  import { useStore } from './useStore.js'
  import { formatCutPrice, getDistance } from '@shared/util.js'

  const props = defineProps({
  })

  const { isMobileSize } = useWatchWindowSize()

  const store = useStore()

  const { activeProperty } = storeToRefs(store)

  let map = null
  let markers = {}
  let opening = null
  let position = {}
  let retry = 0

  const {
    google_maps_api_key: googleMapsApiKey,
    locale,
    map_id: mapId,
    type,
  } = window.app.page

  /**
   * Google Maps API読み込み後イベント
   * callbackで呼ばれるようにglobalにしておく
   */
  window.initializeMap = () => initializeMap()

  watch(activeProperty, (property) => property ? openInfoWindow(property) : closeInfoWindow(opening))

  onMounted(() => initializeMap())

  /**
   * サムネイルを閉じる
   */
  const closeInfoWindow = (info) => {
    if (info) {
      info.close()
      opening = null
    }
  }

  /**
   * マーカーの作成
   *  今のところそれほど要らないかもしれないけど、オプションが増えたときのために作った
   */
  const createMarker = async (text, options = {}, icon = {}) => {
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker")

    const content = document.createElement("div");
    content.className = "price-tag";
    content.textContent = text

    const args = {
      map,
      content,
    }

    return {
      marker: new AdvancedMarkerElement({ ...options, ...args }),
      content
    }
  }

  /**
   * @deprecated JS側で処理することにしたので、これは不要になった（一応残しておく）
   * 物件の位置情報を取得する
   */
  const getLocations = () => {
    const { callPost } = useAjax()
    const proc = (properties) => {
      callPost('/locations.json', { properties, type })
        .then((response) => {
          if (response.code == 'success') {
            responses.push(response)
            putMarkersAll()
          }
        })
    }

    // 件数が多いと時間がかかるので分割する
    const codes = store.properties.map((property) => property.code)
    const firstCount = 200
    proc(codes.slice(0, firstCount))
    if (codes.length > firstCount) {
      proc(codes.slice(firstCount))
    }
  }

  /**
   * 地図の初期化
   */
  const initializeMap = () => {
    if (!store.properties) {
      return setTimeout(() => initializeMap(), 100)
    }

    const loader = new Loader({
      apiKey: googleMapsApiKey,
      language: locale,
      mapIds: [mapId],
      version: "weekly",
    })

    loader.importLibrary('maps').then(async ({ Map }) => {
      // const { Map } = await google.maps.importLibrary("maps");

      map = new Map(document.getElementById("map"), {
        mapTypeControl: false,
        mapId: mapId,
        gestureHandling: "greedy",
      })

      map.addListener('click', () => {
        if (opening) {
          store.resetActive()
        }
      })

      if (isMobileSize.value) {
        map.addListener('dragstart', () => {
          store.resetActive()
        })
      }

      setTimeout(() => document.getElementById('map').style.position = 'sticky', 100)

      if (store.properties.length == 0) {
        return
      }

      putMarkersAll()
    })
  }

  /**
   * 物件情報のwindowを表示する
   */
  const openInfoWindow = async (property) => {
    if (!map || isMobileSize.value) return

    const data = markers[property.code]
    if (!data) return

    if (opening && opening != data.info) {
      closeInfoWindow(opening)
    }

    if (!data.info) {
      const { InfoWindow } = await google.maps.importLibrary("maps");
      const content = document.getElementById('property-dummy').innerHTML
      data.info = new InfoWindow({ content, disableAutoPan: true })
      markers[property.code] = { ...markers[property.code], info: data.info }
    }
    const info = data.info
    opening = info
    info.disableAutoPan = position.clientX ? true : false
    info.open(map, data.marker)

    if (position.clientX) {
      setTimeout(() => {
        setInfoWindowOffset(info)
        position = {}
      }, 10)
    }
    else {
      setTimeout(() => $(".gm-style-iw-c").css('opacity', 1), 100)
    }
  }

  /**
   * マーカーを置く
   */
  const putMarker = async (property) => {
    const price = formatCutPrice(property.price)
    const { marker, content } = await createMarker(price, { position: { lat: property.lat, lng: property.lng } })

    markers[property.code] = { marker }
    marker.addListener('click', (e) => {
      const info = markers[property.code].info
      if (info != opening) {
        store.resetActive()
      }

      if (isMobileSize.value) {
        store.active(property.code, 'Map')
      }
      else if (store.activeProperty) {
        // visitProperty()
        store.resetActive()
      }
      else {
        store.active(property.code, 'Map')
      }
    })

    /*
    content.addEventListener('mouseover', (e) => {
      position = e
      store.active(property.code)
    })

    content.addEventListener('mouseout', () => {
      closeInfoWindow(markers[property.code].info)
      store.resetActive()
    })
    */
  }

  /**
   * サムネイル表示の位置を調整する
   */
  const setInfoWindowOffset = (info) => {
    if (!opening || isMobileSize.value) return

    if ($(".gm-style-iw-c").length == 0) {
      if (retry == 10) {
        retry = 0
        opening = null
        return
      }

      retry++
      setTimeout(() => setInfoWindowOffset(info), 100)
      return
    }

    retry = 0
    const x = position.clientX - $('.map_column').offset().left
    const y = position.clientY - Math.max(0, 110 - $("body, html").scrollTop()) // $('.map_column').offset().top

    // infoWindowの大きさ
    const width = $(".gm-style-iw-c").width()
    const half = width / 2
    const height = $(".gm-style-iw-c").height()

    const offset = { x: 0, y: 0 }
    if (x < half) {
      offset.x = half - x
    }
    else if (x > $('.map_column').width() - half) {
      offset.x = -1 * (half + 20 + x - $('.map_column').width())
    }

    if (y < height) {
      if (offset.x != 0) {
        // 横に出す
        offset.x = (offset.x < 0 ? - 1 : 1) * (height / 2 + 20)
        offset.y = height - y + 40
      }
      else {
        offset.y = height + 80
      }
    }
    info.set("pixelOffset", new google.maps.Size(offset.x, offset.y))
    $(".gm-style-iw-c").css('opacity', 1).css('visibility', 'hidden')
    setTimeout(() => {
      $(".gm-style-iw-c").css('visibility', 'visible') // なぜか枠線がつくようになってこれを入れると解消する、、
    }, 10)
  }

  /**
   * 地図の中央位置とMarkerをセットする
   * Mapのロードと物件情報の取得を並列で行っていて、両方が終わったら処理されるようにする
   */
  const putMarkersAll = () => {
    if (!map || store.properties.length == 0) return

    // 中心の計算
    let lat = 0
    let lng = 0
    let distance = 0
    const properties = store.properties.filter((a) => a.lat)

    properties.forEach((a, i) => {
      lat += a.lat
      lng += a.lng
      properties.slice(i + 1).forEach((b) => {
        const current = getDistance(a, b)
        if (!isNaN(current)) {
          distance = Math.max(distance, current)
        }
      })
    })

    const center = { lat: lat / store.properties.length, lng: lng / store.properties.length }

    map.setCenter({ lat: center.lat, lng: center.lng })
    setZoom(distance * 1000)

    properties.forEach((property) => putMarker(property))
  }

  /**
   * 距離からズームレベルをセットする
   */
  const setZoom = (distance) => {
    // zoom 13から順に閾値を定義
    const levels = [5000, 10000, 20000, 40000, 100000, 200000, 500000, 1000000, 2000000, 3000000, 3000000, 5000000]
    levels.find((limit, index) => {
      if (distance <= limit) {
        map.setZoom(13 - index)
        return true
      }
      return false
    })
  }

  /**
   * マーカーをクリックした際に物件詳細に遷移する
   */
  const visitProperty = () => store.activeProperty && (window.location.href = store.activeProperty.path)
</script>

<template>
  <div class="map_column">
    <div id="map"></div>
  </div>
</template>
